import { Link } from "react-router-dom";
import { siteData } from "@/store/siteData";
import { storySlug } from "@/utils/blog";

export default function StoriesArticles() {
  const data = siteData.getStories();

  return (
    <section data-edit="stories" className="bg-white py-20">
      <div className="container-x">
        {/* Başlık + CTA */}
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">
              {data.tagline}
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-ink sm:text-4xl lg:text-[2.5rem]">
              {data.title}
            </h2>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-muted lg:text-[17px]">
              {data.subtitle}
            </p>
          </div>
          <Link
            to="/makaleler"
            className="hidden shrink-0 items-center gap-1.5 rounded-full border border-line px-4 py-2 text-sm font-semibold text-ink transition-colors hover:border-brand hover:text-brand sm:inline-flex"
          >
            <span>Tüm Makaleleri Gör</span>
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        {/* 4 makale — yan yana dikey kart */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {data.items.map((a) => (
            <Link
              key={a.id}
              to={`/makale/${storySlug(a)}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-soft transition-all hover:-translate-y-1 hover:border-brand/30 hover:shadow-card"
            >
              {/* Görsel - üstte */}
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={a.imageUrl}
                  alt={a.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* İçerik - altta */}
              <div className="flex flex-1 flex-col gap-2.5 p-6">
                <p className="flex items-center gap-1.5 text-xs font-medium text-muted">
                  <i className="ri-calendar-line text-sm"></i>
                  <span>{a.date}</span>
                </p>
                <h3 className="font-display text-lg font-bold leading-tight text-ink transition-colors group-hover:text-brand sm:text-xl">
                  {a.title}
                </h3>
                <p className="line-clamp-2 text-sm leading-relaxed text-muted">
                  {a.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-brand">
                  <span>Makaleyi Oku</span>
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
